function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.98686 4.98438C6.84457 4.98438 6.72925 5.0997 6.72925 5.24199V10.1108C6.72925 10.253 6.84457 10.3684 6.98686 10.3684C7.12915 10.3684 7.24447 10.253 7.24447 10.1108V5.24199C7.24447 5.0997 7.12915 4.98438 6.98686 4.98438Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.94706 4.98438C3.80477 4.98438 3.68945 5.0997 3.68945 5.24199V10.1108C3.68945 10.253 3.80477 10.3684 3.94706 10.3684C4.08935 10.3684 4.20468 10.253 4.20468 10.1108V5.24199C4.20468 5.0997 4.08935 4.98438 3.94706 4.98438Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.73166 4.27481V10.6218C1.73166 10.9969 1.86922 11.3492 2.10952 11.602C2.34871 11.8555 2.68159 11.9994 3.02997 12H7.90404C8.25252 11.9994 8.5854 11.8555 8.8245 11.602C9.0648 11.3492 9.20236 10.9969 9.20236 10.6218V4.27481C9.68005 4.14801 9.98958 3.68653 9.92568 3.19636C9.86168 2.7063 9.44417 2.33971 8.94988 2.33961H7.63094V2.0176C7.63244 1.7468 7.52537 1.48678 7.33368 1.29548C7.14198 1.10429 6.88155 0.99782 6.61076 1.00003H4.32326C4.05246 0.99782 3.79204 1.10429 3.60034 1.29548C3.40864 1.48678 3.30157 1.7468 3.30308 2.0176V2.33961H1.98413C1.48984 2.33971 1.07233 2.7063 1.00833 3.19636C0.944434 3.68653 1.25397 4.14801 1.73166 4.27481ZM7.90404 11.4848H3.02997C2.58952 11.4848 2.24688 11.1064 2.24688 10.6218V4.29745H8.68714V10.6218C8.68714 11.1064 8.3445 11.4848 7.90404 11.4848ZM3.8183 2.0176C3.81659 1.88346 3.86932 1.75435 3.96451 1.65966C4.05961 1.56497 4.18902 1.51294 4.32326 1.51525H6.61076C6.745 1.51294 6.87441 1.56497 6.9695 1.65966C7.0647 1.75425 7.11742 1.88346 7.11571 2.0176V2.33961H3.8183V2.0176ZM1.98413 2.85483H8.94988C9.20598 2.85483 9.41358 3.06243 9.41358 3.31853C9.41358 3.57463 9.20598 3.78223 8.94988 3.78223H1.98413C1.72803 3.78223 1.52044 3.57463 1.52044 3.31853C1.52044 3.06243 1.72803 2.85483 1.98413 2.85483Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.46708 4.98438C5.32479 4.98438 5.20947 5.0997 5.20947 5.24199V10.1108C5.20947 10.253 5.32479 10.3684 5.46708 10.3684C5.60936 10.3684 5.72468 10.253 5.72468 10.1108V5.24199C5.72468 5.0997 5.60936 4.98438 5.46708 4.98438Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.6
});

function SvgUtilicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilicon);
export default __webpack_public_path__ + "static/media/util.icon.ddfc4725.svg";
export { ForwardRef as ReactComponent };